import React from "react";
import { StyleSheet, View } from "react-native";

import { useGameStore } from "../stores/useGameStoreFacade";
import { useModalStore } from "../stores/useModalStore";
import AppButton from "./ui/AppButton";

/**
 * Replaces the word chips once a game ends with the way back to the report.
 * The numbers live in the report with the paths (owner, 2026-10-21). New
 * games start from the header's New Game button.
 */
const EndOfGameBar: React.FC = () => {
  const gameStatus = useGameStore((s) => s.gameStatus);
  const gameReport = useGameStore((s) => s.gameReport);
  const showGameReportModal = useModalStore((s) => s.showGameReportModal);

  if (gameStatus !== "won" && gameStatus !== "given_up") return null;
  if (!gameReport) return null;

  return (
    <View style={styles.bar} testID="end-of-game-bar">
      <AppButton
        label="View report"
        variant="secondary"
        onPress={() => showGameReportModal(gameReport)}
        testID="end-view-report"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    alignItems: "center",
    alignSelf: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
});

export default EndOfGameBar;
